import React, { useState, useEffect } from 'react';
import { Navbar, Badge, Modal, NavbarBrand, NavItem, NavbarHeader, NavDropdown, Nav, Container, Row, Button, Col, Tab, Tabs } from 'react-bootstrap';
import ReactDOM from 'react-dom/client';
import { Line } from 'react-chartjs-2';
import { Doughnut } from 'react-chartjs-2';

import Marquee from "react-fast-marquee";


import Offcanvas from 'react-bootstrap/Offcanvas';

// Main CSS
/*import './index.css';*/

// Modules
import MarketsProducts from './components/MarketsProducts';
import CountryPeg from './components/CountryPeg';
import Trend from './components/Trend';
import TimeChange from './components/TimeChange';
import PricingGrid from './components/PricingGrid';
import FutureCurves from './components/FutureCurves';



function IndexPricing(props) {

  // ***************************************************
  // ***************************************************
  // ***************************************************
  // **************** Bootstrap Offcanvas ********************
  // ***************************************************
  // ***************************************************
  // ***************************************************
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  /*const [showFactors, setShowFactors] = useState(false);
  const handleCloseFactors = () => setShowFactors(false);
  const handleShowFactors = () => setShowFactors(true);*/



  // Data coming from child class
  let [geoTechJsonResponse, setGeoTech] = useState(1);

  let [organic, setOrganicArray] = useState(135);
  let [fairTrade, setFairTrade] = useState(110);

  let [jsonResponseTimeChange, setTimeChange] = useState(1);
  let [jsonResponseCountryPeg, setCountryPeg] = useState(1);



  // ***************************************************
  // ***************************************************
  // ***************************************************
  // ****************LOGS ********************
  // ***************************************************
  // ***************************************************
  // ***************************************************
  const [myLogs, setMyLogs] = useState([]);


  //const myLogsJson = JSON.parse(myLogs)

  // Effect to amend the array when state changes
  useEffect(() => {
    // *****************************************
    // *** LOGS
    // *****************************************
    // Get current timestamp
    const currentTimestamp = new Date().getTime();
    // Convert timestamp to date object
    const date = new Date(currentTimestamp);
    // Format date
    const formattedDate = date.toLocaleString();
    //const jsonObject = { 'factor': name, 'value': value }; // JSON object to add
    const jsonObject = { timestamp: formattedDate, 'user': 'user1', factor: 'organic', value: organic };
    // to convert the object to a string.
    const jsonString = JSON.stringify(jsonObject);
    const newArray = [...myLogs, jsonString];
    // Update the state with the new array
    setMyLogs(newArray);

  }, [organic]); // Only run when myLogs changes or another attribute


  // Effect to amend the array when state changes
  useEffect(() => {
    // *****************************************
    // *** LOGS
    // *****************************************
    // Get current timestamp
    const currentTimestamp = new Date().getTime();
    // Convert timestamp to date object
    const date = new Date(currentTimestamp);
    // Format date
    const formattedDate = date.toLocaleString();
    //const jsonObject = { 'factor': name, 'value': value }; // JSON object to add
    const jsonObject = { timestamp: formattedDate, 'user': 'user1', factor: 'fairTrade', value: fairTrade };
    // to convert the object to a string.
    const jsonString = JSON.stringify(jsonObject);
    const newArray = [...myLogs, jsonString];
    // Update the state with the new array
    setMyLogs(newArray);

  }, [fairTrade]); // Only run when myLogs changes or another attribute


  // Effect to amend the array when state changes
  useEffect(() => {
    // *****************************************
    // *** LOGS
    // *****************************************
    // Get current timestamp
    const currentTimestamp = new Date().getTime();
    // Convert timestamp to date object
    const date = new Date(currentTimestamp);
    // Format date
    const formattedDate = date.toLocaleString();
    //const jsonObject = { 'factor': name, 'value': value }; // JSON object to add
    const jsonObject = { timestamp: formattedDate, 'user': 'user1', factor: 'TimeChange', value: jsonResponseTimeChange };
    // to convert the object to a string.
    const jsonString = JSON.stringify(jsonObject);
    const newArray = [...myLogs, jsonString];
    // Update the state with the new array
    setMyLogs(newArray);

  }, [jsonResponseTimeChange]); // Only run when myLogs changes or another attribute


  // Effect to amend the array when state changes
  useEffect(() => {
    // *****************************************
    // *** LOGS
    // *****************************************
    // Get current timestamp
    const currentTimestamp = new Date().getTime();
    // Convert timestamp to date object
    const date = new Date(currentTimestamp);
    // Format date
    const formattedDate = date.toLocaleString();
    //const jsonObject = { 'factor': name, 'value': value }; // JSON object to add
    const jsonObject = { timestamp: formattedDate, 'user': 'user1', factor: 'CountryPeg', value: jsonResponseCountryPeg };
    // to convert the object to a string.
    const jsonString = JSON.stringify(jsonObject);
    const newArray = [...myLogs, jsonString];
    // Update the state with the new array
    setMyLogs(newArray);

  }, [jsonResponseCountryPeg]); // Only run when myLogs changes or another attribute



  // Effect to amend the array when state changes
  useEffect(() => {
    // *****************************************
    // *** LOGS
    // *****************************************
    // Get current timestamp
    const currentTimestamp = new Date().getTime();
    // Convert timestamp to date object
    const date = new Date(currentTimestamp);
    // Format date
    const formattedDate = date.toLocaleString();
    //const jsonObject = { 'factor': name, 'value': value }; // JSON object to add
    const jsonObject = { timestamp: formattedDate, 'user': 'user1', factor: 'GeoTech', value: geoTechJsonResponse };
    // to convert the object to a string.
    const jsonString = JSON.stringify(jsonObject);
    const newArray = [...myLogs, jsonString];
    // Update the state with the new array
    setMyLogs(newArray);

  }, [geoTechJsonResponse]); // Only run when myLogs changes or another attribute





  return (
    <>
      <Row style={{ marginLeft: 0, marginRight: 0 }}>
          <Marquee className="TickerBar" speed={40} direction={"left"}>
          extensive rainfall in Brazil's coffee-growing zones inflicted harm on coffee crops (13 Apr 24)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Tight robusta coffee supplies from Vietnam&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          ICE-monitored robusta coffee inventories on Feb21 fell to a record low&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </Marquee>
      </Row>

      
      <Offcanvas show={show} onHide={handleClose} style={{ width: '50%' }}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Logs &#x2022; Track changes</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {/*{myLogs}*/}
          {JSON.stringify(myLogs)}
        </Offcanvas.Body>
      </Offcanvas>



      {/*<Button variant="primary" onClick={handleShowFactors}>
        Show factors
      </Button>

      <Modal show={showFactors} onHide={handleCloseFactors}>
        <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>{organic}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseFactors}>
            Close
          </Button>
          <Button variant="primary" onClick={handleCloseFactors}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>*/}



      <Tabs
        defaultActiveKey="inputs"
        id="fill-tab-example"
        className="mb-3"
        fill
      >
        <Tab eventKey="inputs" title="Factors & prices (USD per lb.)" className='tab'>

          <Row style={{ marginLeft: 0, marginRight: 0 }}>

            <Col sm={6} md={6} lg={4} xl={3} xxl={3} style={{ padding: "0.2em" }}>
              <MarketsProducts jsonResponseGeoTech={setGeoTech} />
              <CountryPeg jsonResponseCountryPeg={setCountryPeg} />
            </Col>

            <Col sm={6} md={6} lg={3} xl={2} xxl={2} style={{ padding: "0.2em" }}>
              <Trend inputOrganic={setOrganicArray} inputFairTrade={setFairTrade} />
              <TimeChange jsonResponseTimeChange={setTimeChange} />
            </Col>

            {/* Filters and pricing grids */}
            <Col sm={12} md={12} lg={5} xl={7} xxl={7} style={{ padding: "0.2em" }}>
              <PricingGrid
                trend="organic & fair trade"
                geoTech={geoTechJsonResponse}
                jsonResponseCountryPeg={jsonResponseCountryPeg}
                organic={organic}
                fairTrade={fairTrade}
                jsonResponseTimeChange={jsonResponseTimeChange}
              />
            </Col>

            <Col sm={12} md={12} lg={12} xl={12} xxl={12} style={{ padding: "0.2em", textAlign: "center" }}>
              <Button size="sm" onClick={handleShow} className="custom-btn-logs">
              Logs &#x2022; Track changes
              </Button>
            </Col>


          </Row>

        </Tab>
        {/*<Tab eventKey="prices" title="Prices only">
          <Row style={{ marginLeft: 0, marginRight: 0 }}>
            <Col sm={12} md={12} lg={12} xl={12} xxl={12} style={{ padding: "0.2em" }}>
              <PricingGrid
                trend="organic & fair trade"
                geoTech={geoTechJsonResponse}
                jsonResponseCountryPeg={jsonResponseCountryPeg}
                organic={organic}
                fairTrade={fairTrade}
                jsonResponseTimeChange={jsonResponseTimeChange}
              />
            </Col>
          </Row>
        </Tab>*/}
        <Tab eventKey="charts" title="Future curves">
          <FutureCurves />
        </Tab>
      </Tabs>



    </>
  );

}


export default IndexPricing;